// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_1MXsQ","subTitleText":"_34mb3","singleTitle":"_2qkAY","tableView":"_31Rgy","tableHeaderStrip":"_1t1sf","ctaText":"_1wRdu","tabNavs":"_1SCuI","active":"_2JVu2"};